import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Chip } from '@mui/material';
import ColorizeIcon from '@mui/icons-material/Colorize';
import * as Icons from "@mui/icons-material";
import Avatar from "@mui/material/Avatar";

export const SelectCell = ({ props }: { props: any }): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (
      divWidth['element'] > divWidth['cell'] ||
      (props.value?.status_lamp && props.value?.icon)
    ) {
      setTooltip(true);
    }
  });

  const getFieldContent = useCallback(() => {
    if (props.value?.name === undefined) {
      return {
        element: props.value?.id,
        tooltipValue: props.value?.id,
      };
    } else {
      if (props.value?.color && typeof props.value?.color === 'string') {
        return {
          element: (
            <>
              <Chip
                style={{
                  background: `${props.value?.color}`,
                  color: '#fff',
                }}
                icon={
                  <ColorizeIcon
                    fontSize="small"
                    color={'disabled'}
                    sx={{ color: 'white' }}
                  />
                }
                label={`${props.value?.color}`}
              />
            </>
          ),
          tooltipValue: props.value?.color,
        };
      }
      if (
        props.value?.color &&
        typeof props.value?.color === 'object' &&
        !props.value?.status_lamp
      ) {
        return {
          element: (
            <>
              <Chip
                style={{
                  background: `${props.value?.color?.color}`,
                  color: '#fff',
                }}
                label={`${props.value?.name}`}
              />
            </>
          ),
          tooltipValue: props.value?.name,
        };
      }

      if (props.value?.icon === null && !props.value?.status_lamp) {

        const IconComponent = Icons[props.value?.name as keyof typeof Icons];

        return {
          element: (
            <>
              <Chip
                variant="outlined"
                style={{ color: '#666' }}
                icon={IconComponent ? <IconComponent /> : <></>}
                label={props.value?.name}
              />
            </>
          ),
          tooltipValue: props.value?.name,
        };
      }

      if (props.value?.status_lamp) {
        if (props.value?.icon) {
          const withDate = props?.field === 'service_reservation_status';
          const IconComponent = Icons[props.value?.icon.name as keyof typeof Icons];

          return {
            element: (
              <>
                <Avatar
                  sx={{
                    background: props.value?.color?.color,
                    width: 20,
                    height: 20,
                    '& .MuiSvgIcon-root':{
                      fontSize: '16px'
                    }
                  }}
                >
                  {props.value?.icon && (
                    <>{IconComponent ? <IconComponent /> : null}</>
                  )}
                </Avatar>
              </>
            ),
            tooltipValue: `${props.value?.name} ${
              withDate &&
              props.row?.service_reservation_status_updated_at &&
              `- ${props.row.service_reservation_status_updated_at}`
            }`,
          };
        }

        return {
          element: (
            <>
              <div
                className="fill-div h-full"
                style={{ background: `${props?.value?.color?.color}` }}
              ></div>
            </>
          ),
          tooltipValue: props?.value?.name,
        };
      } else {
        let nameValue = props.value?.name;

        if (props.field === 'headquarters_address' && !nameValue) {
          nameValue = `${props.value?.zip_code} ${props.value?.city} ${props.value?.address_line1} ${props.value?.address_line2}`;
        }

        return {
          element: (
            <>
              <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                <div
                  style={{
                    color: props?.value?.color?.color ? '#fff' : '',
                    background: `${props?.value?.color?.color}`,
                  }}
                >
                  {nameValue}
                </div>
              </div>
            </>
          ),
          tooltipValue: props.value?.name,
        };
      }
    }
  }, [props]);

  return (
    <div ref={divRef}>
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={getFieldContent().tooltipValue}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <div>{getFieldContent().element}</div>
          </Tooltip>
        </>
      ) : (
        <>{getFieldContent().element}</>
      )}
    </div>
  );
};
